@if (!isCollapsed) {
  <div>
    <div class="navrail">
      <div class="item-container">
        <div class="item">
          <div class="icon shimmer"></div>
          <div class="label shimmer"></div>
        </div>
      </div>
      <div class="uilab-nav-rail__divider"></div>
      <div class="item-container">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <div class="item">
            <div class="icon shimmer"></div>
            <div class="label shimmer"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (isCollapsed) {
  <div>
    <div class="navrail-small">
      <div class="item-container-small">
        <div class="item-small">
          <div class="icon shimmer"></div>
        </div>
      </div>
      <div class="uilab-nav-rail__divider"></div>
      <div class="item-container-small">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <div class="item-small">
            <div class="icon shimmer"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
